interface ITrafficContainer {
    valueField: HTMLInputElement;
    items: NodeListOf<HTMLElement>;
}

export default class TrafficSelector {
    protected trafficContainer: Array<ITrafficContainer> = [];

    constructor(container: HTMLElement) {
        const _this = this;
        container
            .querySelectorAll('.rw-traffic-selector')
            .forEach((trafficContainer: HTMLElement) => {
                _this.trafficContainer.push({
                    valueField: trafficContainer.querySelector('input'),
                    items: trafficContainer.querySelectorAll('.signal')
                });
            });
        _this.trafficContainer.forEach((trafficContainer) => {
            trafficContainer.items.forEach((trafficItem, index) => {
                trafficItem.addEventListener('click', () => {
                    trafficContainer.items.forEach((el) => {
                        el.classList.remove('active');
                    });
                    trafficItem.classList.add('active');
                    trafficContainer.valueField.value = 'signal-' + index.toString();
                });
            });
        });
    }
}
